var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.696094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18182 0H17.7851C21.2231 0 24 2.77686 24 6.21488V17.8182C24 21.2231 21.2231 24 17.8182 24H6.18182C2.77686 24 0 21.2231 0 17.8182V6.18182C0 2.77686 2.77686 0 6.18182 0ZM17.8177 23.3388C20.859 23.3388 23.3383 20.8595 23.3383 17.8182V6.21486C23.3383 3.17354 20.859 0.694196 17.8177 0.694196H6.18131C3.13998 0.694196 0.660645 3.17354 0.660645 6.21486V17.8182C0.660645 20.8595 3.13998 23.3388 6.18131 23.3388H17.8177Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0413 4H12.3967C10.843 4 9.58678 5.2562 9.58678 6.80992V9.02479H8.19835C8.09917 9.02479 8 9.12397 8 9.22314V11.5372C8 11.6364 8.09917 11.7355 8.19835 11.7355H9.58678V11.8347V19.3719C9.58678 19.4711 9.68595 19.5702 9.78512 19.5702H12.595C12.6942 19.5702 12.7934 19.4711 12.7934 19.3719V11.7355H14.8099C14.9091 11.7355 15.0083 11.6694 15.0083 11.5702L15.2066 9.2562C15.2066 9.15703 15.1405 9.05785 15.0083 9.05785H12.7934V7.43802C12.7934 7.04132 13.0909 6.7438 13.4876 6.7438H15.0413C15.1405 6.7438 15.2397 6.64463 15.2397 6.54545V4.2314C15.2397 4.09917 15.1405 4 15.0413 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.08bd5fb457a132b2179f1705950d27d9.svg";
export { ForwardRef as ReactComponent };